import Dexie from 'dexie';
import { DB_NAME, STORES, STORES_V1 } from './schema';

// Instance unique IndexedDB (Dexie)
var db = new Dexie( DB_NAME );

// Upgrade v1 → v2 : ajout index composé [user_uuid+created_at]
db.version( 1 ).stores( STORES_V1 );
db.version( 2 ).stores( STORES );

export default db;
